module.exports = __webpack_public_path__ + "bgHeaderService.png?9fe5dbaee343a4588f6aa4470688867c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bgHeaderService.png
// module id = 88
// module chunks = 0